/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */

import { nodesApi } from "../AlfrescoApi.js";
import { useConfigStore } from "@/stores/config.js";

const PRISTY_CONFIG_NODE_ID = "pristy-config";

/**
 * Checks the health of the configuration folder in Alfresco.
 *
 * Verifies that the pristy-config node (fixed NodeRef) exists and contains
 * a sub-folder matching the current INSTANCE_NAME.
 */
class ConfigHealthService {
  /**
   * Verify the instance config folder exists under pristy-config.
   *
   * @returns {Promise<{ok: boolean, detail: string}>}
   *   ok=true  → instance folder found
   *   ok=false → pristy-config or instance folder missing
   */
  async check() {
    const configStore = useConfigStore();
    const instanceName = configStore.INSTANCE_NAME;

    if (!instanceName || instanceName === "/") {
      return { ok: false, detail: "INSTANCE_NAME_NOT_SET" };
    }

    try {
      const result = await nodesApi.listNodeChildren(PRISTY_CONFIG_NODE_ID);
      const found = result.list.entries.some(
        (e) => e.entry.name === instanceName,
      );

      if (found) {
        return { ok: true, detail: "OK" };
      }

      return { ok: false, detail: "CONFIG_FOLDER_NOT_FOUND" };
    } catch (error) {
      console.error("ConfigHealthService.check failed", error);
      return { ok: false, detail: "CHECK_FAILED" };
    }
  }
}

export default new ConfigHealthService();
